import type { RazorpayConstructor } from "@/modules/billing/razorpay/types/razorpay.ts";
import { loadScript } from "@/utils/loadScript.ts";
import { makeOnce } from "@warrenio/utils/makeOnce";
import { discardPromise } from "@warrenio/utils/promise/discardPromise";
import { useEffect } from "react";

export const razorpayLoader = makeOnce(async (): Promise<RazorpayConstructor> => {
    await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    return window.Razorpay;
});

export function usePreloadRazorpay() {
    useEffect(() => {
        discardPromise(razorpayLoader());
    }, []);
}
